<template>
  <v-layout>
    <v-container grid-list-lg>
        <v-layout row wrap>
            <v-flex xs12>
          <!-- <h5 class="text-xs-center">***</h5>
          <h2 class="text-xs-center feature_products_title">Kategori <span>Listesi</span></h2>
          <div class="title_border"></div> -->
        </v-flex>
            <v-flex xs-12 sm6 md6 lg3 v-for="(item_category,index) in item_categories" :key="index">
                <v-card class="CategoryDetail d-flex " :to="'/CategoryDetail/' + item_category.id" height="100">
                <v-card-title>
            <h3>{{item_category.category_name}}</h3>
          </v-card-title>
                    <!-- <div>{{item_category.category_name}} </div> -->
                    <div>
                        <v-img
                            :src="item_category.image"
                            height="80" width="80" class="right">
                        </v-img> 
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
  import firebase from "firebase";
  import moment from 'moment';
//  import https, { request } from 'https';
//   import axios from "axios";
// import qs from "query-string";
import EventServicex from "@/services/EventService.js"

  export default {
    name:'About',  
    data(){
      return{
        item_categories:[],
         sortBy: 'name'
      }
    },
    methods:{
        
    }, 
    created(){


      var db = firebase.firestore();
      // Current Currency   
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.currency = doc.data().currency
      })

      // Show All Items
      // let cref = db.collection('category').orderBy('modifytime', 'desc')

         let cref = db.collection('category')
let query = cref.where('parentgroup_id', '==', null).orderBy("name").get()
      .then(snapshot => {
        snapshot.forEach(doc  => {                    
            this.item_categories.push({
              id:doc.id,
          //    image:doc.data().image,
          image:doc.data().note,
              category_name:doc.data().name,
              timestamp:moment(doc.data().modifytime).format('ll')
            })          
        })
      })
     
     
     
    //  let cref = db.collection('category').orderBy('modifytime', 'desc')

    //   cref.onSnapshot(snapshot => {
    //     snapshot.docChanges().forEach(change => {
    //       if(change.type == 'added'){
    //         let doc = change.doc
    //         this.item_categories.push({
    //           id:doc.id,
    //       //    image:doc.data().image,
    //       image:null,
    //           category_name:doc.data().name,
    //           timestamp:moment(doc.data().modifytime).format('ll')
    //         })
    //       }
    //     })
    //   })



    } 
  }
</script>

<style scoped>
.product_category{
    border:1px solid #EEEEEE;
    font-size: 18px;
    height:80px;
    padding:0 20px;
}
 .product_category>:first-child:not(.v-btn):not(.v-chip) {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    margin-top: 25px;
}
.product_category>:nth-child(2):not(.v-btn):not(.v-chip) {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    margin-top: 8px;
}
 h5{
    font-size: 24px!important;
    letter-spacing: 0.4px!important;
    line-height: 15px;
    font-family: 'Yesteryear', cursive;
    text-transform: capitalize;
    color:#3E3939;
  }
  .feature_products_title{
    font-weight: 600;
    font-size: 35px;
    color: #3E3939;
    margin:0px 0px 15px;
    font-family: 'Lobster Two', cursive;
    text-transform: capitalize;
  }

</style>
   


// WEBPACK FOOTER //
// src/components/shop/sections/Category.vue